<script setup lang="ts">
import { Head } from '@inertiajs/vue3';
import SiteHeader from '@/components/SiteHeader.vue';
import HomeLayout from '@/layouts/HomeLayout.vue';
import AddressQuoteForm from '@/components/AddressQuoteForm.vue';

defineOptions({ layout: HomeLayout });
</script>

<template>
    <div class="min-h-screen bg-white">
        <Head title="Get Started - Free Price Quote">
            <meta
                head-key="description"
                name="description"
                content="Get a free instant lawn mowing price quote from Mow Managers. Enter your address and zip code to get started in seconds."
            />
            <link
                rel="canonical"
                href="https://mowmanagers.com/get-started"
            />
            <meta
                property="og:title"
                content="Get Started - Free Price Quote | Mow Managers"
            />
            <meta
                property="og:description"
                content="Get a free instant lawn mowing price quote. Enter your address and zip code to get started."
            />
            <meta property="og:type" content="website" />
            <meta
                property="og:url"
                content="https://mowmanagers.com/get-started"
            />
        </Head>

        <SiteHeader />

        <section aria-labelledby="get-started-heading" class="py-20 lg:py-32">
            <div class="mx-auto max-w-2xl px-4 text-center sm:px-6">
                <h1
                    id="get-started-heading"
                    class="text-4xl leading-tight font-bold whitespace-nowrap sm:text-5xl lg:text-[56px] lg:leading-[64px]"
                >
                    <span class="text-mm-dark">Get started with a</span><br />
                    <span class="text-mm-green">free price quote.</span>
                </h1>

                <p class="mt-5 text-[18px] font-medium text-[#6d706d]">
                    Enter your address and zip code to get started.
                </p>

                <div class="mx-auto mt-10 max-w-[400px]">
                    <AddressQuoteForm variant="card" input-id-prefix="gs" />
                </div>
            </div>
        </section>
    </div>
</template>
